import store from "../redux/store.ts";
import pageIcon from "../assets/image/icons/left-side-menu/page.svg";
import { api } from "../api/api";
import { mapping } from "./mapping";
import { app } from "./app";
import { helpersFunc } from "../config/helpers";
import lFindIndex from "lodash/findIndex";
import {
  leftSideActions,
  leftSideSelectors,
} from "../redux/reducers/leftSideMenu.ts";
import { notifyError } from "shared/errors/notificate.ts";

export const contacts = {
  loadContactsList: (list) => {
    const leftSide = {
      type: "contacts",
      label: "Recently imported",
      bottomList: [
        {
          id: 1,
          image: pageIcon,
          title: "All contacts",
          link: "/contacts",
        },
      ],
      list,
    };
    store.dispatch(leftSideActions.setLeftSide(leftSide));
  },
  getRecentImports: async () => {
    if (!leftSideSelectors.isContact(store.getState())) {
      contacts.loadContactsList([]);
    }
    try {
      const response = await api.getRecentImportsApi();
      const formatResponse = mapping.buildRecentImports(
        response.data ? response.data : []
      );
      store.dispatch({
        type: "RECENT_IMPORTS",
        payload: {
          imports: response.data,
        },
      });
      contacts.loadContactsList(formatResponse);
    } catch (error) {
      store.dispatch({
        type: "RECENT_IMPORTS",
        payload: {
          imports: [],
        },
      });
      contacts.loadContactsList([]);
      helpersFunc.logEnjectServicePromise(error);
    }
  },
  getImports: async (id) => {
    try {
      const response = await api.getImportsApi(id);
      return response;
    } catch (error) {
      console.error(error);
    }
  },

  getContacts: async (data, status, companyId, rerender = true, modal) => {
    if (rerender) {
      contacts.clearContacts();
      app.changePageContentLoaderStatus(true);
      app.changeTableContentLoaderStatus(true);
    }
    if (modal) {
      app.changePageModalLoader(true);
    }
    let contactsArray = [];
    let executions = [];
    let response;
    try {
      if (
        (data.status && data.status !== "Compose") ||
        (status && status !== "Compose")
      ) {
        const contactsExecutionsRes = await api.getContactsExecutionsApi({
          skip: data.skip,
          filter: companyId ? `campaign_id eq '${companyId}'` : data.filter,
          orderby:
            data.orderby && data.orderby !== "imported asc"
              ? data.orderby
              : "created asc, id asc",
          keywords: data.keywords,
        });
        if (contactsExecutionsRes.status === 200) {
          executions = contactsExecutionsRes.data.documents;
        }
        response = contactsExecutionsRes;
        const linkedin_contacts = contactsExecutionsRes.data.documents.map(
          (el) => {
            const { id, ...linkedin_contact } = el.linkedin_contact;
            return { ...el, ...linkedin_contact };
          }
        );

        response = {
          ...contactsExecutionsRes,
          data: {
            ...contactsExecutionsRes.data,
            documents: [...linkedin_contacts],
          },
        };
      } else {
        response = await api.getContactsApi(data);
      }

      if (!response.data) {
        contacts.haveContacts(false);
      }

      if (response.data && !modal) {
        if (response.data.documents.length > 0) {
          contacts.haveContacts(true);
          store.dispatch({
            type: "CONTACTS_COUNT",
            payload: {
              contactsCount: response.data.total,
            },
          });
        }
        contactsArray =
          (data.status && data.status !== "Compose") ||
          (status && status !== "Compose")
            ? mapping.buildCampaignContacts(response.data.documents, executions)
            : mapping.buildContacts(response.data.documents);
      }

      app.updateErrorRequest({
        contacts: false,
      });

      if (!modal) {
        store.dispatch({
          type: "ALL_CONTACTS",
          payload: {
            contacts: contactsArray,
          },
        });
      }
      return response;
    } catch (error) {
      store.dispatch(
        app.updateErrorRequest({
          contacts: true,
        })
      );

      contacts.haveContacts(false);
      notifyError(error);

      store.dispatch({
        type: "ALL_CONTACTS",
        payload: {
          contacts: [],
        },
      });
      return { status: "error", response: error.response };
    } finally {
      rerender && app.changePageContentLoaderStatus(false);
      rerender && app.changeTableContentLoaderStatus(false);
      setTimeout(() => {
        app.changePageModalLoader(false);
      }, 200);
    }
  },
  haveContacts: (status) => {
    store.dispatch({
      type: "HAVE_CONTACTS",
      payload: {
        haveContacts: status,
      },
    });
  },
  columnSize: (data) => {
    store.dispatch({
      type: "COLUMN_SIZE",
      payload: {
        columnSize: data,
      },
    });
  },

  typeContacts: (data) => {
    store.dispatch({
      type: "TYPE_CONTACTS",
      payload: {
        typeContacts: data,
      },
    });
  },
  typeCampaigns: (data) => {
    store.dispatch({
      type: "TYPE_CAMPAIGNS",
      payload: {
        typeCampaigns: data,
      },
    });
  },

  changeContactsPage: (page) => {
    store.dispatch({
      type: "CONTACTS_PAGE",
      payload: {
        contactsPage: page,
      },
    });
  },
  changeContactsPageModal: (page) => {
    store.dispatch({
      type: "CONTACTS_PAGE_MODAL",
      payload: {
        contactsPageModal: page,
      },
    });
  },

  clearContacts: () => {
    store.dispatch({
      type: "ALL_CONTACTS",
      payload: {
        contacts: [],
      },
    });
    store.dispatch({
      type: "CONTACTS_COUNT",
      payload: {
        contactsCount: 0,
      },
    });

    store.dispatch({
      type: "HAVE_CONTACTS",
      payload: {
        haveContacts: false,
      },
    });
  },
  cancelExecution: (data) => {
    store.dispatch({
      type: "ALL_CONTACTS",
      payload: {
        contacts: data,
      },
    });
    app.changeTableContentLoaderStatus(false);
  },
  updateImportedContact: (data) => {
    const tempImports = store.getState().contacts.imports;
    const index = lFindIndex(tempImports, {
      id: data.id,
    });
    tempImports.splice(index, 1, data);
    store.dispatch({
      type: "UPDATE_IMPORTED_CONTACT",
      payload: {
        imports: tempImports,
      },
    });
  },
};
